import { ReactElement } from 'react'
import FadeCarousel from '../../../components/FadeCarousel'
import logo from './assets/amor_e_saude.png'
import image1 from './assets/image1.png'
import image2 from './assets/image2.png'
import image3 from './assets/image3.png'
import image4 from './assets/image4.png'
import * as S from './styled'

const CAROUSEL_IMAGES = [image1, image2, image3, image4]

export default function Clinic (): ReactElement {
  return <S.Container id="clinicas">
    <S.Content>
      <S.TextContent>
        <S.LogoContainer>
          <img src={logo} alt="AmorSaúde" />
        </S.LogoContainer>

        <S.TopContent>
          <h1>Clínica parceira com atendimento de excelência e sem burocracia!</h1>

          <p><strong>Consultas</strong> e <strong>exames</strong> com condições especiais para quem não tem acesso a planos de saúde ou não pode esperar meses na fila por um atendimento.</p>
        </S.TopContent>

        <S.BottomContent>
          <h4>Consultas <span>presencial ou online</span></h4>

          <S.PriceContainer>
            <p>
              <strong>Primeira consulta:</strong>
              <br />
              <small>A partir da 2ª consulta: R$ 87,50</small>
            </p>

            <p>R$ <span>50</span></p>
          </S.PriceContainer>

          <span><small>*Os valores apresentados podem variar</small></span>
        </S.BottomContent>
      </S.TextContent>

      <S.CarouselContainer>
        <FadeCarousel>
          {CAROUSEL_IMAGES.map((image) => <img src={image} alt="" key={image} />)}
        </FadeCarousel>
      </S.CarouselContainer>
    </S.Content>
  </S.Container>
}
